import { useLeadershipWheelStore } from '../store/useLeadershipWheelStore';
import { motion, AnimatePresence } from 'framer-motion';

export const MessageContainer = () => {
  const { leadershipWheelPage, FocusArea, SubFocusArea } = useLeadershipWheelStore();

  const message = !FocusArea ? 'initial' : FocusArea && !SubFocusArea ? 'trait' : 'subTrait';
  const title = `${message}Title` as 'initialTitle' | 'traitTitle' | 'subTraitTitle';

  // Animation variants for messages
  const variants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    exit: { opacity: 0 },
  };

  return (
    <div className="mx-auto grid h-full items-center  justify-center">
      <AnimatePresence mode="wait">
        <motion.div
          key={message}
          variants={variants}
          initial="hidden"
          animate="visible"
          exit="hidden"
          transition={{ ease: 'easeOut', duration: 0.5 }}>
          <p key={title} className="text-28-32 mb-sh-30 text-center font-haffer font-bold">
            {leadershipWheelPage?.messages?.[title]?.replace('${trait}', SubFocusArea?.focusArea || '') || ''}
          </p>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
